import { addRecentInvite, getRecentInvites } from '@/services/recent-invites.service'
import { logger } from '@/utils/logger'

const state = {
  recentInvites: []
}

const mutations = {
  SET_RECENT_INVITES(state, invites) {
    state.recentInvites = invites
  }
}

const actions = {
  async fetchRecentInvites({ commit, rootGetters }) {
    try {
      const invites = await getRecentInvites(rootGetters.user.uid)
      commit('SET_RECENT_INVITES', invites)
    } catch (error) {
      logger.error('Error fetching recent invites:', error.message)
    }
  },

  async addRecentInvite({ dispatch, rootGetters }, person) {
    try {
      await addRecentInvite(rootGetters.user.uid, person)
      await dispatch('fetchRecentInvites')
    } catch (error) {
      logger.error('Error adding recent invite:', error.message)
    }
  }
}

const getters = {
  recentInvites: (state) => state.recentInvites
}

export default {
  state,
  mutations,
  actions,
  getters
}
